module.exports = __webpack_public_path__ + "img/lens-167-minus-04.d092fe05.png";